import DamageType from "./DamageType";

class Damage {

    #damages

    constructor() {
        this.damages = {}
        DamageType.ALL.forEach(damageType => {
            this.damages[damageType] = 0
        })
    }

    add(damageType, damage) {
        this.damages[damageType] = this.damages[damageType] + damage;
    }

    subtract(damageType, damage) {
        this.damages[damageType] = this.damages[damageType] - damage;
    }

    getByDamageType(damageType) {
        return this.damages[damageType]
    }
}

export default Damage;